import { ISimpleTableCellRenderProps } from "@asup/simple-table";
import { Badge } from "react-bootstrap";

/**
 * Read-only table cell renderer that displays TLF tag values as pill-shaped
 * Bootstrap Badge chips. Renders nothing when the row has no tags.
 *
 * @param props - The component props.
 * @param props.rowData - Row data whose `tlfTags` array is rendered as chips.
 * @returns A div containing one Badge per tag, or an empty fragment when there are no tags.
 */
export const TlfItemTableTagsCell = ({
  rowData,
}: ISimpleTableCellRenderProps): React.ReactElement => {
  const tags = Array.isArray(rowData.tlfTags) ? (rowData.tlfTags as string[]) : [];

  return (
    <div className="tlf-tags-cell">
      {tags.map((tag) => (
        <Badge
          key={tag}
          bg="secondary"
          className="me-1"
        >
          {tag}
        </Badge>
      ))}
    </div>
  );
};

TlfItemTableTagsCell.displayName = "TlfItemTableTagsCell";
